import axios from 'axios'

/**
 * @desc Fetches all Volume Buys for specified supplier
 * @desc fetchVolumePromotionRulesForSupplier in BFF
 * @param {String} supplierId
 * @param {Object} options
 */
export const fetchVolumePromotions = (supplierId, options = {}) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/volume-promotion-rules`, {
      params: options
    })
    .then((res) => res.data)

/**
 * @desc Creates new Volume Buy for product
 * @desc addVolumePromotionRule in BFF
 * @param {String} supplierId
 * @param {Object} promotion
 */
export const createVolumePromotion = (supplierId, promotion) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/volume-promotion-rules`,
      promotion
    )
    .then((res) => res.data)

/**
 * @desc Create multiple Volume Buys for product
 * @desc addVolumePromotionRules in BFF
 * @param {String} supplierId
 * @param {Object} promotions
 */
export const createVolumePromotions = (supplierId, promotions) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/volume-promotion-rules/bulk`,
      promotions
    )
    .then((res) => res.data)

/**
 * @desc Updates promotion
 * @desc editVolumePromotionRule in BFF
 * @param {String} supplierId
 * @param {String} volumePromotionId
 * @param {Object} promotion
 */
export const updateVolumePromotion = (
  supplierId,
  volumePromotionId,
  promotion
) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/volume-promotion-rules/${volumePromotionId}`,
      promotion
    )
    .then((res) => res.data)

/**
 * @desc Deletes promotion
 * @desc deleteVolumePromotionRule in BFF
 * @param {String} supplierId
 * @param {String} volumePromotionId
 */
export const deleteVolumePromotion = (supplierId, volumePromotionId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/volume-promotion-rules/${volumePromotionId}`
    )
    .then((res) => res.data)
